import { LoadingIcon as LoadingDs } from "@packages/ds";
import styled from "styled-components";

export const FormWrapper = styled.form`
  padding: 32px;
  min-height: 200px;
  background-color: var(--section-snow-background-color, var(--snow));
`;

export const Text = styled.p`
  margin-top: 8px;
`;

export const EnvironmentContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 40px;
`;

export const Loading = styled(LoadingDs)`
  display: block;
  margin-top: 50px;
`;
